import { useDeviceState } from '@/lib/useCommon';
import style from './index.module.less';
import RtcClient from '@/lib/RtcClient';
import { MediaType } from '@volcengine/rtc';
import { updateLocalUser } from '@/store/slices/room';
import { useDispatch } from 'react-redux';

function AudioController(props: React.HTMLAttributes<HTMLDivElement>) {
  const { className, ...rest } = props;
  const { isAudioPublished } = useDeviceState();
  const dispatch = useDispatch();

  const handleStartAudio = async () => {
    // 如果还没有加入房间，则先加入

    RtcClient.publishStream(MediaType.AUDIO);
    await RtcClient.startAudioCapture();

    dispatch(
      updateLocalUser({
        publishAudio: true,
      })
    );
  };

  const handleStopAudio = async () => {
    RtcClient.unpublishStream(MediaType.AUDIO);
    await RtcClient.stopAudioCapture();

    dispatch(
      updateLocalUser({
        publishAudio: false,
      })
    );

    console.log('停止说话');
  };

  return (
    <div className={`${className} ${style.audioInputBox}`} {...rest}>
      {!isAudioPublished ? (
        <div className={style.text} onClick={handleStartAudio}>
          开始说话
        </div>
      ) : (
        <div className={style.stopSpeechButton} onClick={handleStopAudio}>
          停止说话
        </div>
      )}
    </div>
  );
}

export default AudioController;
